import isomorphicCookie from 'isomorphic-cookie'

export const deleteUuid = () => {
  isomorphicCookie.remove('web_uuid', {
    secure: process.env.NODE_ENV === 'production',
  })
}
